import { useDownloadFileMutation } from '@/hooks/useDownloadFileMutation';
import Download from '@/images/Download.svg';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import { getItemPresenterTypeAndLabels } from '@/utils/utils';
import { LibraryItem, LibraryItemStatus } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from './components';

interface Props {
    video: LibraryItem;
    closeMenu: () => void;
}

export const DownloadMenuItem = ({ video, closeMenu }: Props) => {
    const mixpanel = useAnalytics();

    const onCancelDownload = () =>
        mixpanel?.track('options-download', {
            event: MixPanelEvent.CANCEL,
            videoId: video?.id,
            ...getItemPresenterTypeAndLabels(video as LibraryItem),
        });
    const { mutateAsync: download } = useDownloadFileMutation(onCancelDownload);

    if (video!.status !== LibraryItemStatus.Done) {
        return null;
    }

    return (
        <MenuItem
            onClick={() => {
                mixpanel?.track('options-download', {
                    event: MixPanelEvent.CLICK,
                    videoId: video!.id,
                    ...getItemPresenterTypeAndLabels(video as LibraryItem),
                });
                download({ dataurl: video!.video_url!, filename: video!.name ?? 'video', extension: '.mp4' });
                closeMenu();
            }}>
            <ListItemIcon>
                <img src={Download} />
            </ListItemIcon>
            <ListItemText>Download</ListItemText>
        </MenuItem>
    );
};
